'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("topbarUserMenu", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./topbar-user-menu.html")
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/user-menu/topbar-user-menu.js
// module id = 3026
// module chunks = 13